(() => {
  if (window.luxsolFeatureExplorerReady) return;
  window.luxsolFeatureExplorerReady = true;
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-feature-explorer]').forEach(section => {
      if (section.dataset.ready) return;
      const choices = [...section.querySelectorAll('[data-feature-choice]')];
      const photos = [...section.querySelectorAll('[data-feature-photo]')];
      const column = section.querySelector('.ls-feature-explorer__choices');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const movements = new Map();
      let active = choices.find(choice => choice.open) || choices[0];
      let revision = 0;
      let lastWidth = 0;
      const reserveCopy = () => {
        const width = column.clientWidth;
        if (!width) return;
        let height = 0;
        choices.forEach(choice => {
          const copy = choice.querySelector('.ls-feature-explorer__copy').cloneNode(true);
          copy.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;width:${width}px;height:auto;`;
          copy.setAttribute('aria-hidden', 'true');
          column.append(copy);
          height = Math.max(height, copy.getBoundingClientRect().height);
          copy.remove();
        });
        section.style.setProperty('--feature-copy-height', `${Math.ceil(height)}px`);
        lastWidth = width;
      };
      photos.forEach(photo => {
        const selected = photo.dataset.featurePhoto === active.dataset.featureChoice;
        photo.hidden = false;
        photo.dataset.active = String(selected);
        photo.setAttribute('aria-hidden', String(!selected));
      });
      active.open = true;
      reserveCopy();
      section.dataset.ready = 'true';
      const select = choice => {
        if (choice === active && choice.open) return;
        const before = choices.map(item => item.getBoundingClientRect().top);
        movements.forEach(animation => animation.cancel());
        movements.clear();
        active = choice;
        choices.forEach(item => { item.open = item === choice; });
        if (!reduced.matches) {
          choices.forEach((item, index) => {
            const delta = before[index] - item.getBoundingClientRect().top;
            if (Math.abs(delta) > 1) movements.set(item, item.animate([
              { transform: `translateY(${delta}px)` }, { transform: 'translateY(0)' }
            ], { duration: 280, easing: 'cubic-bezier(.4,0,.2,1)' }));
          });
          choice.querySelector('.ls-feature-explorer__copy').animate([
            { opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 240, easing: 'cubic-bezier(0,0,.2,1)' });
        }
        const next = photos.find(photo => photo.dataset.featurePhoto === choice.dataset.featureChoice);
        const token = ++revision;
        const image = next?.querySelector('img');
        if (image) image.loading = 'eager';
        const ready = image?.decode ? image.decode().catch(() => {}) : Promise.resolve();
        ready.then(() => {
          if (token !== revision || !next) return;
          photos.forEach(photo => {
            const selected = photo === next;
            photo.dataset.active = String(selected);
            photo.setAttribute('aria-hidden', String(!selected));
          });
        });
      };
      choices.forEach(choice => {
        choice.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          select(choice);
        });
        choice.addEventListener('toggle', () => {
          if (choice.open && choice !== active) select(choice);
          if (choice === active && !choice.open) choice.open = true;
        });
      });
      new ResizeObserver(() => { if (column.clientWidth !== lastWidth) reserveCopy(); }).observe(column);
      document.fonts?.ready.then(reserveCopy);
      const preload = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        photos.forEach(photo => { const image = photo.querySelector('img'); if (image) image.loading = 'eager'; });
        preload.disconnect();
      }, { rootMargin: '400px' });
      preload.observe(section);
      section.addEventListener('shopify:block:select', event => {
        const choice = event.target.closest('[data-feature-choice]');
        if (choice) select(choice);
      });
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
